module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_ynn-a2fee6e4b3ebc2fedeffc64a63f6ebe2.png";